import { InputsHeader } from '../InputsHeader';
import { NumericInput } from '../form-controls';
import { Grid } from '../layout';

export function Nitrogen() {
  return (
    <>
      <InputsHeader title="Nitrogen" subtitle="Input Values" />
      <Grid columns={2} columnSpacing={{ xs: 2, sm: 3 }}>
        <NumericInput
          name="starterFertilizer.nitrogen.preplant"
          label="Preplant"
        />
        <NumericInput
          name="starterFertilizer.nitrogen.mar1V2"
          label="Mar 1 - V2"
        />
      </Grid>
    </>
  );
}
